module.exports = __webpack_public_path__ + "media/images/emblems/Rheinau-blazon-5cc11e011dd25dda68509dadb35d8afa.svg";